import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@features/auth/services/auth.service';

/**
 * Guard para rutas públicas fuera del layout (p. ej. `not-found`,
 * `service-unavailable`) que no pasan por `notAuthenticatedGuard` ni
 * `isAuthenticatedGuard`. No bloquea la navegación ni hace peticiones de red:
 * solo resuelve `AuthService.authStatus` fuera de `checking` para que el
 * loader global deje de mostrarse.
 */
export const publicRouteGuard: CanActivateFn = () => {
  inject(AuthService).resolveAuthStatusFromToken();
  return true;
};
